import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class JsonService extends RestfulService<Models.FakeJSON> {

  constructor(private restService: RestService) {
    super(Models.FakeJSON);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('fakeJSONs');
  }

}
